import store from "../store";

export default {
  install: function(Vue) {
    Vue.mixin({
      computed: {
        berechtigungen() {
          return store.state.berechtigungen;
        },
        gruppen() {
          return store.state.gruppen;
        }
      },
      methods: {
        // Zimmereinteilung: Feature für den Kunden eingeschaltet (Konfiguration func_show_zimmereinteilung = 1)
        // Methode statt Computed, weil $CONST nicht reaktiv ist (Konfiguration wird nachgeladen)
        zimmerFreigeschaltet() {
          const wert = String(this.$CONST?.("CONFIG")?.FUNC_SHOW_ZIMMEREINTEILUNG ?? "").trim().toLowerCase();
          return wert === "1" || wert === "true";
        },
        // Feature eingeschaltet UND Modulberechtigung m_zimmereinteilung.<recht> (read/create/update/delete)
        zimmerRecht(recht) {
          return this.zimmerFreigeschaltet() && !!store.state.berechtigungen?.m_zimmereinteilung?.[recht];
        },
      }
    });
  }
};
